import { cn } from '@heroui/react'

interface UploadIconProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  iconClassName?: string
}

const sizeClasses = {
  sm: 'w-12 h-12',
  md: 'w-16 h-16',
  lg: 'w-20 h-20',
}

const iconSizeClasses = {
  sm: 'w-6 h-6',
  md: 'w-8 h-8',
  lg: 'w-10 h-10',
}

export const UploadIcon = ({
  size = 'md',
  className,
  iconClassName,
}: UploadIconProps) => {
  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-full bg-default-100',
        sizeClasses[size],
        className
      )}
    >
      <svg
        className={cn('text-default-400', iconSizeClasses[size], iconClassName)}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
        />
      </svg>
    </div>
  )
}
